import type {SanityModuleLooxReviews} from '../../../types';
import {useLoadScript} from '@shopify/hydrogen';

export default function LooxReviews({
  module,
}: {
  module: SanityModuleLooxReviews;
}) {
  if (!module.active) {
    return <></>;
  }
  const scriptStatus = useLoadScript(
    'https://loox.io/widget/4yxToKYeUo/loox.1635228300187.js?shop=helmetking-0001.myshopify.com',
  );

  if (scriptStatus === 'loading' || scriptStatus === 'error') {
    return <></>;
  }

  return (
    <div id="looxCarousel" className="w-full">
      <iframe
        id="looxCarouselFrame"
        src="https://loox.io/widget/4yxToKYeUo/carousel?frame_id=looxCarouselFrame&h=1672393856021&language=zh-TW&show_more_btn=true&max_width=1920&use_widget_font=true"
        className="w-full"
      ></iframe>
    </div>
  );
}
